import GroupDetail from "./GroupDetail"

export default  GroupDetail;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/GroupDetail/index.js